import { FC, MouseEvent, useState } from 'react';
import { useParams } from 'react-router-dom';
import UnsavedChangesModal from '../../../common/UnsavedChangesModal/UnsavedChangesModal';
import ClassBaseForm from '../ClassBaseForm/ClassBaseForm';
import { ClassBaseFormValues } from '../ClassBaseForm/ClassBaseForm.types';
import { SubTitle } from '../../Classes/ClassForm/ClassForm.styles';
import { readOnlyLabelTableText } from '../../../constants/GlobalTexts';

const EditClassBase: FC = () => {
  const { classNo, baseNo } = useParams();
  const _classNo = classNo as unknown as number;
  const _baseNo = baseNo as unknown as number;

  const [formValues, setFormValues] = useState<ClassBaseFormValues>({
    classNo: _classNo,
    baseNo: _baseNo,
  });

  const handleSave = (event: MouseEvent) => {
    event.preventDefault();
  };

  return (
    <>
      <ClassBaseForm
        formValues={formValues}
        setFormValues={setFormValues}
        headerTitle={`View Class - ${classNo} | Base - ${baseNo}`}
        saveDisabled={true}
        handleSave={handleSave}
        isButtonLoading={false}
        isFormReadOnly={true}
        hasImageForm={true}
      />
      <SubTitle>{readOnlyLabelTableText}</SubTitle>
      <UnsavedChangesModal unsavedChangesExist={false} />
    </>
  );
};

export default EditClassBase;